import { render, staticRenderFns } from "./JdsAvatar.vue?vue&type=template&id=3c0caf8e&"
import script from "./JdsAvatar.vue?vue&type=script&lang=ts&"
export * from "./JdsAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports